import { combineReducers } from "redux";
import { AddNoteBoard } from "./AddNoteBoard";

import { boardAttributeForm } from "./board-attribute-form";
import { createattributereducer } from "./create-attribute-reducers";
import fetchAllBoards from "./fetch-all-boards";
import { loginDetails } from "./login-details";
import { statusworkflow } from "./statusworkflow";

const allReducers = combineReducers({
  allBoards: fetchAllBoards,
  loginDetails: loginDetails,
  attributes: createattributereducer,
  boardAttribute: boardAttributeForm,
  statusworkflow: statusworkflow,
  note: AddNoteBoard,
});

export default allReducers;
